import { Stack, Typography } from "@mui/material";
import { cloneElement, isValidElement, type ReactElement, type ReactNode } from "react";
import { AppButton } from "../form";

type Props = {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  actionIcon?: ReactNode;
};

/** Consistent empty state for list panels (OpenAPI-style). */
export default function PageEmptyState({ message, actionLabel, onAction, actionIcon }: Props) {
  const sizedIcon =
    actionIcon && isValidElement(actionIcon)
      ? cloneElement(actionIcon as ReactElement<{ sx?: object; fontSize?: string }>, {
          fontSize: "small",
          sx: {
            fontSize: "1.05rem !important",
            ...((actionIcon as ReactElement<{ sx?: object }>).props.sx || {}),
          },
        })
      : actionIcon;

  return (
    <Stack spacing={1.25} alignItems="flex-start" py={1.5} px={0.5}>
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
      {actionLabel && onAction ? (
        <AppButton size="medium" variant="outlined" startIcon={sizedIcon} onClick={onAction}>
          {actionLabel}
        </AppButton>
      ) : null}
    </Stack>
  );
}
